import { jsx } from 'react/jsx-runtime';
import { EGDSLayout } from '../../layout/layout/index.esm.js';
import 'react';
import { EGDSLayoutSpaces } from '../../layout/types/index.esm.js';
import '../../utils/index_orig/index.esm.js';
import '../../utils/theme/theme-provider/index.esm.js';
import { EGDSLayoutFlexAlignContents, EGDSLayoutFlexAlignItems, EGDSLayoutFlexBlockSizes, EGDSLayoutFlexDirections, EGDSLayoutFlexJustifyContents, EGDSLayoutFlexWraps } from '../types/index.esm.js';
import styles from '../../styles/uitk-egds-layout-flex.css';
import { classNames } from '../../utils/classnames/index.esm.js';
const getClassNameList = classNames.bind(styles);
const EGDSLayoutFlex = props => {
  const {
    alignContent,
    alignItems,
    blockSize,
    children,
    className,
    direction,
    justifyContent,
    inline,
    space,
    tag,
    domRef,
    wrap,
    dataTestId,
    ...attributes
  } = props;
  const baseClass = 'uitk-layout-flex';
  const wrapperClassNames = getClassNameList(baseClass, alignContent && `${baseClass}-${EGDSLayoutFlexAlignContents.get(alignContent)}`, alignItems && `${baseClass}-${EGDSLayoutFlexAlignItems.get(alignItems)}`, blockSize && `${baseClass}-${EGDSLayoutFlexBlockSizes.get(blockSize)}`, direction && `${baseClass}-${EGDSLayoutFlexDirections.get(direction)}`, justifyContent && `${baseClass}-${EGDSLayoutFlexJustifyContents.get(justifyContent)}`, inline && `${baseClass}-inline`, space && `${baseClass}-${EGDSLayoutSpaces.get(space)}`, wrap && `${baseClass}-${EGDSLayoutFlexWraps.get(wrap)}`, className);
  return children ? jsx(EGDSLayout, {
    className: wrapperClassNames,
    tag: tag,
    domRef: domRef,
    ...attributes,
    ...(dataTestId && {
      'data-test-id': dataTestId
    }),
    children: children
  }) : null;
};
EGDSLayoutFlex.displayName = 'EGDSLayoutFlex';
export { EGDSLayoutFlex };